import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "@core/services/toast.service";

@Injectable({ providedIn: 'root' })
export class FormErrorService {
  #forms = new Map<string, FormGroup>();
  #translate = inject(TranslateService);
  #toastService = inject(ToastService);

  registerForm(key: string, form: FormGroup) {
    this.#forms.set(key, form);
  }

  unregisterForm(key: string) {
    this.#forms.delete(key);
  }

  applyValidationErrors(errors: Record<string, { key: string; params?: any }>) {
    for (const [field, errorData] of Object.entries(errors)) {
      let found = false;

      for (const [formKey, form] of this.#forms.entries()) {
        const control = form.get(field);
        if (control) {
          control.setErrors({
            ...(control.errors ?? {}),
            backend: {
              key: errorData.key,
              params: errorData.params ?? {},
            },
          });
          control.markAsTouched();
          found = true;
        }
      }

      if (!found) {
        this.#toastService.message(this.#translate.instant(errorData.key, errorData.params), { type: 'danger' } );
      }
    }
  }
}
